import { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { IonContent, IonPage, IonText, IonImg, IonIcon, IonicSwiper } from '@ionic/react';
import { Accordion, AccordionSection } from 'react-rainbow-components';
import { Constants } from '../defines/Constants';
import { CleanHTML } from '../defines/Functions';
import SwiperCore, { Navigation, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import axios from 'axios';
import Loading from '../components/Loading';
import HeaderImage from '../components/HeaderImage';
import Fancybox from '../components/Fancybox';
import './Page.css';
import calendarImg from '../assets/images/calendar.svg';
import eyeImg from '../assets/images/eye.svg';
import arrowBack from '../assets/images/arrow-back.svg';

SwiperCore.use([IonicSwiper, Navigation, Autoplay]);
const Page = (props: any) => {
    const pageId = props.location.state;
    const pageApi = Constants.api.page;
    const [page, setPage] = useState() as any;
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        let hitIds = {
            id: [] as any
        };
        let updateHits = 'F';
        let pageHits = localStorage.getItem("pageHits") as any;
        let pageHitsObj = JSON.parse(pageHits);
        if (pageHitsObj === null) {
            hitIds.id.push(pageId);
            localStorage.setItem("pageHits", JSON.stringify(hitIds));
            updateHits = 'T';
        }
        if (pageHitsObj !== null && !pageHitsObj.id.includes(pageId)) {
            pageHitsObj.id.push(pageId);
            localStorage.setItem("pageHits", JSON.stringify(pageHitsObj));
            updateHits = 'T';
        }
        const getPage = async () => {
            setLoading(true);
            try {
                const results = await axios.post(pageApi, { id: pageId, update_hits: updateHits }, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                });
                if (results.status === 200) {
                    setPage(results.data.page_items[0]);
                    setLoading(false);
                }
            } catch (error: any) {
                console.log(error);
            }
        }
        getPage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const history = useHistory();
    const onBackClick = () => {
        history.goBack();
    }
    return (
        <IonPage className="page-padding-top">
            <IonContent fullscreen>
                {(page !== undefined && Object.keys(page).length !== 0 && page.header_image !== null) &&
                    <HeaderImage headerImage={Constants.uploads + 'pages/' + page.header_image} />
                }
                {!loading ?
                    page !== undefined && Object.keys(page).length !== 0 &&
                    <div className="ion-padding">
                        <div className="page-content">
                            <h6>{page.title}</h6>
                            <div className="info">
                                <IonIcon src={calendarImg} />
                                <span>
                                    <b>تاریخ : </b>
                                    {page.datetime}
                                </span>
                                <IonIcon src={eyeImg} />
                                <span>
                                    <b>بازدید : </b>
                                    {page.hits}
                                </span>
                            </div>
                            <IonText>
                                {CleanHTML(page.text)}
                            </IonText>
                            {page.images !== null &&
                                <Swiper dir="rtl" slidesPerView={1} loop autoplay={{ "delay": 2500, "disableOnInteraction": false }} navigation allowTouchMove={true} className="slider-container">
                                    {page.images.split(',').map((images: any, imagesIndex: number) =>
                                        <SwiperSlide key={"index" + imagesIndex}>
                                            <Fancybox options={{ infinite: false }}>
                                                <div data-fancybox="gallery" data-src={Constants.uploads + 'pages/' + images} >
                                                    <IonImg src={Constants.uploads + 'pages/' + images} />
                                                </div>
                                            </Fancybox>
                                            {/* <IonImg src={Constants.uploads + 'pages/' + images} /> */}
                                        </SwiperSlide>
                                    )}
                                </Swiper>
                            }
                        </div>
                        {(page.accordions !== undefined && page.accordions.length !== 0) &&
                            <Accordion className="page-accordion">
                                {page.accordions.map((accr: any, accrIndex: number) =>
                                    <AccordionSection label={accr.title} key={"index" + accrIndex}>
                                        <IonText>
                                            {CleanHTML(accr.text)}
                                        </IonText>
                                    </AccordionSection>
                                )}
                            </Accordion>
                        }
                        <div className="blog-details-footer-btns">
                            <span onClick={onBackClick}>
                                بازگشت
                                <IonIcon icon={arrowBack} />
                            </span>
                        </div>
                    </div>
                    :
                    <Loading />
                }
            </IonContent>
        </IonPage>
    );
};

export default Page;
